export default __webpack_public_path__ + "static/ring-size-chart-bcd945590cba279744aa07d50cd1a8b2.jpg";